import React, { Component } from "react";
import PropTypes from "prop-types";
import Hammer from "hammerjs";
import { Div, Img, Button } from "glamorous";
import styles from "../../../styles";
import icons from "../../../imgs/icons";

const handleZoomIn = () => state => {
  state.scale = Math.min(state.scale + 0.25, 2.25);
  state.pos.y =
    window.innerHeight / 25 * Math.sin(Math.PI / Math.min(2, state.scale));
  return state;
};

const handleZoomOut = () => state => {
  state.scale = Math.max(state.scale - 0.25, 1);
  state.pos.y =
    window.innerHeight / 25 * Math.sin(Math.PI / Math.min(2, state.scale));
  return state;
};

class Touch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      iconOpacity: 1,
      scale: 1,
      pos: { x: 0, y: 0 }
    };

    // For hammer position/scale tracking
    this.prevState = {
      scale: this.state.scale,
      pos: {
        x: this.state.pos.x,
        y: this.state.pos.y
      }
    };
  }

  componentDidMount() {
    const hammertime = new Hammer(this.refs.bottleWrapper);

    hammertime.get("pinch").set({ enable: true });

    hammertime.on("pinchstart", evt => {
      this.setState({ iconOpacity: 0 });
      hammertime.off("pinchstart");
    });

    hammertime.on("pinch", evt => {
      let { scale, pos } = this.state;
      scale = Math.min(Math.max(this.prevState.scale * evt.scale, 1), 2.5);

      // Always move back to initial pos when zooming out
      if (scale < this.prevState.scale) {
        const halfPi = Math.PI / 2;
        const multiplier = Math.sin(halfPi - halfPi * (2 - Math.min(2, scale)));

        pos.x = pos.x * multiplier;
        pos.y = pos.y * multiplier;
      }

      this.setState({ scale, pos });
    });

    hammertime.on("pinchend", evt => {
      this.prevState.scale = this.state.scale;
    });
  }

  render() {
    const bottleWrapperStyle = {
      position: "relative",
      display: "inline-block",
      transform: `scale(${this.state.scale}) translate(${this.state.pos
        .x}px, ${this.state.pos.y}px)`
    };

    return (
      <Div css={styles.label.bottleContainer(this.props.method)}>
        <Button
          onClick={() => this.setState(handleZoomOut())}
          css={styles.label.zoomOut}
        />
        <div ref="bottleWrapper" style={bottleWrapperStyle}>
          <img
            alt=""
            style={styles.label.bottle(this.props.method)}
            src={this.props.bottleImage}
          />
          {this.props.children}
        </div>
        <Img
          src={icons.pinchIcon}
          style={{ opacity: this.state.iconOpacity }}
          css={styles.label.pinchIcon}
        />
        <Button
          onClick={() => this.setState(handleZoomIn())}
          css={styles.label.zoomIn}
        />
      </Div>
    );
  }
}

Touch.propTypes = {
  bottleImage: PropTypes.string.isRequired
};

export default Touch;



// WEBPACK FOOTER //
// ./src/components/areas/PreviewLabel/Touch.js